<template>
  <div :class="['trial-option-recap', optionType]">
    <div class="bulls-eye-container" v-if="hasBullsEye">
      <bullseye-diagram
        :datas="bullseyeDatas"
        :colorScales="colorScales"
        :showTooltip="true"
      ></bullseye-diagram>
    </div>

    
    <div class="fields-container seg-field" v-if="fieldsItemsWithSegs.length>0">
      <div class="field-item" v-for="(item,i) in fieldsItemsWithSegs" :key="item.id">
        <div class="left">
          <div class="option-title">{{item.name || 'Option name'}}</div>
          <template v-for="field in item.fields" >
            <div v-if="field && field.view && field.view.inputType!=='bullseye'" :key="field.id" class="field-info">
              <div class="single" v-if="field.valueType==='parameter'">
                <div class="field-value" v-for="fv in field.value" :key="fv.id">
                  <input-container :readOnly="true" :fieldConfig="fv"></input-container>
                </div>
              </div>
              <div class="multi" v-else>
                <input-container :readOnly="true" :fieldConfig="field"></input-container>
              </div>
            </div>
          </template>
          <div class="legend-wrapper">
            <div class="legend-title">{{colorScales[i].label}} </div>
            <color-legend v-if="colorScales[i].domain()[0]!==colorScales[i].domain()[1]" :colorScale="colorScales[i]"></color-legend>
            <div v-else class="scale-as-dot" :style="{background: colorScales[i](0.5)}"></div>
          </div>
        </div>
        <div class="actions" v-if="(optionType!=='parameters' && (isEditable && !isSaving))">
          <div class="action-btn edit" @click="()=>onEditClicked(item)"></div>
          <div class="action-btn remove" @click="()=>onRemoveClicked(item)"></div>
        </div>
      </div>
    </div>
    <div class="separator" v-if="fieldsItemsWithSegs.length>0 && fieldsItemsWithoutSegs.length>0"></div>
    <div class="fields-container other-fields" v-if="fieldsItemsWithoutSegs.length>0">
      <div class="field-item" v-for="(item) in fieldsItemsWithoutSegs" :key="item.id">
        <div class="left">
          <div class="option-title">{{item.name || ''}}</div>
          <div class="other-fields-wrapper">
            <template v-for="field in item.fields" >
              <div v-if="field && field.view.name && field.view.inputType!=='bullseye' && !field.view.name.includes('IC50') &&  !field.view.name.includes('H')" :key="field.id" class="field-info">
                <div class="single" v-if="field.valueType==='parameter'">
                  <div class="field-value" v-for="fv in field.value" :key="fv.id">
                    
                  </div>
                </div>
                <div class="multi" v-else>
                  <!-- temporary: handling population json config -->
                  <div v-if="field.view.name.includes('Population size')"></div>
                  <input-container v-else :readOnly="true" :showUnits="true" :fieldConfig="field"></input-container>
                </div>
              </div>
            </template>
            <div class="field-info" v-if="hasIonChannels && item.name == 'Custom Drug'">
              <ion-channels 
              :isEditing="false"
              :channelParams="customDrugIonChannelsData"
              ></ion-channels>
            </div>
          </div>
        </div>
        <div class="actions" v-if="isEditable">
          <div class="action-btn edit" @click="()=>!isSaving && onEditClicked(item)"></div>
          <div class="action-btn remove" @click="()=>!isSaving && onRemoveClicked(item)" v-if="optionType!=='parameters'"></div>
        </div>
      </div>
    </div>
    <!-- <div class="fields-container">
      <div class="field-item" v-for="item in values" :key="item.id">
        <div class="param-name">(OPT){{item.name}}</div>
        <div class="param-values" v-for="field in item.fields" :key="field.id">
          (FIELD){{field.name}}
          <info-note-tooltip v-if="field.description" :text="field.description" />
          
          <div v-if="field.value" class="field-val">{{getFieldValue(field)}}</div>
          <div v-if="field.subfields && !field.segmentList" class="field-val">
              <div class="subfield-val" v-for="subField in field.subfields" :key="subField.id">
                (SUBFIELD){{subField.name}}: {{getFieldValue(subField)}}
              </div>
            </div>
          <template v-id="field.segmentList">
            <template v-if="field.subfields">
              <div class="segment-val" v-for="seg in field.segmentList" :key="seg.segmentId">
                <div class="subfiled-val" v-for="subfield in seg.subfields" :key="subfield.id">
                  <label>(SEGMENT-SUBFIELD){{subfield.name}}:</label>{{getFieldValue(subfield)}}<span>{{subfield.unitType}}</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="segment-val" v-for="seg in field.segmentList" :key="seg.segmentId">
                <label v-if="seg.segmentId">Segment:</label>{{seg.segmentId}}
                <label>(SEGMENT)</label>{{getFieldValue(seg)}} <span>{{field.unitType}}</span>
              </div>
            </template>
            
          </template>
          
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import BullseyeDiagram from '@/components/CaseDashboard/BullseyeDiagram'
import { getColorScales } from '@/utils/colorScales'
import { getFieldValue } from '@/utils/ConfigUtils'
import { computeDomain } from '@/utils/SegmentUtils'
import { formatValue } from '@/utils'
import InputContainer from '@/components/inputs/InputContainer'
import ColorLegend from '@/components/commons/ColorLegend'
import CustomDrugValidationPlot from '@/components/trial/CustomDrugValidationPlot'
import IonChannels from '@/components/inputs/IonChannels'

export default {
  name: 'TrialOptionRecap',
  props: ['optionType', 'values', 'isEditable', 'isSaving'],
  components: { BullseyeDiagram, InputContainer, ColorLegend, CustomDrugValidationPlot, IonChannels },
  data() {
    return {
      plotKey: 0,
      doseConcentrationsRecap: [],
      channelColors: ['blue', 'red', 'yellow', 'green', 'orange', 'black', 'grey']
    }
  },
  computed: {
    hasBullsEye() {
      return this.bullseyeDatas.length > 0
    },
    hasIonChannels() {
      return this.customDrugIonChannelsData.length > 0
    },
    activeConfigs() {
      // let datas = []
      // // this.activeConfigs = []
      // this.values.forEach((config,i) => {
      //   let configData = []
      //   if(config.fields){
      //     config.fields.forEach(field => {
      //       if(field.segmentConfig){
      //         if (field.segmentList){
      //           configData.push(field)
      //         }
      //       } else {
      //         configData.push(field)
      //       }
      //     })
      //   }
      //   if(configData.length>0) datas[i] = configData
      // })
      // return datas
      let temp = this.values[0].fields ? this.values : [{ fields: this.values }]
      let result = temp.map(config => {
        return config.fields
      })
      return result
    },
    customDrugIonChannelsData() {
      let items = this.fieldsItemsWithoutSegs || []
      let ionChannels = []
      items.forEach(item => {
        item.fields.forEach(field => {
          if (field.view.name) if(field.view.name.includes('IC50') || field.view.name.includes('H')) ionChannels.push(field)
        })
      })
      let deepChannelParams = JSON.parse(JSON.stringify(ionChannels));
      ionChannels = deepChannelParams.map(channel => {
          return {channel: channel.view.name, value: channel.value[0]}
      })
      return ionChannels
    },
    bullseyeDatas() {
      let datas = []
      let formatFieldValue = value => {
        if (typeof value === 'object') {
          return value.name || 'Function'
        } else if (isNaN(+value)) return value
        else return formatValue(value)
      }
      this.fieldsItemsWithSegs.forEach(ob => {
        let configDatas = []
        let paramName = ob.name

        ob.fields.forEach(field => {
          let fieldDatas = []
          if (field && field.view && field.view.inputType === 'bullseye') {
            field.value.forEach(scopeValue => {
              //HE Añadido el "piso" bullseye_scope un poco a ciegas...
              scopeValue.value.forEach(multiValue => {
                let firstVal = multiValue.value[1]
                let valToDisplay = multiValue.value.slice(1).map(val => {
                  let labelString = val.view.name
                  let valueString =
                    val.value.length > 1
                      ? `[${val.value.map(formatFieldValue).join(' , ')}]`
                      : formatFieldValue(val.value[0])
                  return '<br/>&nbsp;&nbsp;&nbsp;' + labelString + ': ' + valueString
                })
                let valToDraw =
                  firstVal.view.inputType === 'sliderRange'
                    ? firstVal.value[0] + (firstVal.value[1] - firstVal.value[0]) / 2
                    : firstVal.value[0]
                let arr = Array.isArray(multiValue.value[0].value)
                  ? multiValue.value[0].value
                  : [multiValue.value[0].value]

                arr.forEach((v, i) => {
                  fieldDatas.push({
                    id: arr[i],
                    value: valToDraw,
                    tooltipData: {
                      mainTitle: paramName,
                      title: scopeValue.view.name,
                      value: valToDisplay,
                    },
                  })
                })
              })
            })
            // if (field.segmentList){
            //   field.segmentList.forEach((seg)=>{
            //     let val = getFieldValue(seg)
            //     if(Array.isArray(val)) val = val.join('<br/>')
            //     fieldDatas.push({
            //       id: seg.segmentId,
            //       value: seg.value ? seg.value.numberValue : 1,
            //       tooltipData: {title:field.name,value: val}
            //     })
            //   })
            // }
          }
          if (fieldDatas.length > 0) configDatas.push(fieldDatas)
        })
        if (configDatas.length > 0) datas.push(configDatas.flat())
      })
      // console.log("bullseyedatas",datas)
      return datas
    },
    // bullseyeDatas () {
    //   let datas = []
    //   // this.activeConfigs = []
    //   this.values.forEach((config,i) => {
    //     let configData = []
    //     if(config.fields){
    //       config.fields.forEach(field => {
    //         if (field.segmentList){
    //           field.segmentList.forEach(seg => {
    //             if (seg.segmentId) {
    //               let val = getFieldValue(seg)
    //               if(Array.isArray(val)) val = val.join('<br/>')
    //               configData.push({
    //                 id: seg.segmentId,
    //                 value: seg.value ? seg.value.numberValue : 1,
    //                 tooltipData: {title:field.name,value: val}
    //               })
    //             }
    //           })
    //         } else if(field.segmentId) { //??? no se si sirve de nada este...
    //           configData.push({
    //             id: field.segmentId,
    //             value: 1,
    //             tooltipData: {title:field.name,value: getFieldValue(field)}
    //           })
    //         }
    //       })
    //     }
    //     if(configData.length>0) {
    //       datas.push(configData)
    //       // this.activeConfigs[i] = true
    //     } else {
    //       // this.activeConfigs[i] = false
    //     }
    //   })
    //   return datas
    // },
    fieldsItems() {
      // return this.values.filter((v,i)=>this.activeConfigs[i])
      if (this.values.length > 0) {
        return this.values[0].fields ? this.values : [{ fields: this.values }]
      }
      return []
    },
    fieldsItemsWithSegs() {
      return this.fieldsItems
        .filter(f => {
          return f.fields.some(field => field && field.view && field.view.inputType === 'bullseye')
        })
        .sort((a, b) => {
          return a.id - b.id
        })
    },
    fieldsItemsWithoutSegs() {
      return this.fieldsItems.filter(f => {
        return !f.fields.some(field => field && field.view && field.view.inputType === 'bullseye')
      })
    },
    colorScales() {
      // MUY CHUNGO, el diseño no esta prepaado para "multiples scales" dentro del mismo "field" (Ischemic injury: [Ischemic injury + scarring])
      // let domains = this.fieldsItemsWithSegs.map((field)=>{
      //   return field.fields.map((f)=>{
      //     return f.value.map((v)=>{
      //       return {max: v.value[0].value[1].view.validate_max, min: v.value[0].value[1].view.validate_min}
      //     })
      //   })
      // }).flat().flat()
      // console.log("domains",domains)

      // let result = getColorScales(this.optionType).map((cs,i)=>{
      //   if(domains[i]){
      //     return cs.domain([domains[i].min[0],domains[i].max[1]])
      //   }
      // }).filter((cs)=>cs)
      // return result
      // let dom = computeDomain(this.fieldsItemsWithSegs.map((f)=>f.fields[0].value).flat())
      let doms = this.fieldsItemsWithSegs.map(f => {
        return computeDomain(f.fields.map(ff => ff.value))
      })
      //Basruilla porque getColorsclaes(..,0) los devuelve todos....
      let colorScales = this.fieldsItemsWithSegs.length
        ? getColorScales(this.optionType, this.fieldsItemsWithSegs.length)
        : []
      let result = colorScales
        .map((cs, i) => {
          if (this.fieldsItems[i]) {
            cs.label = doms[i].label
            return cs.domain(doms[i])
          }
        })
        .filter(cs => cs)
      return result
    },
  },
  methods: {
    getFieldValue(field) {
      // NECESITA MEJORAR!!!
      // Y DEBERIA USARSE "el mismo" para rellenar el tooltip
      // return field.value && (field.value.numberValue || field.value.stringValue)
      return getFieldValue(field)
    },
    // itemHasSemgentField (item) {
    //   return item.fields.some((field)=>field.view.inputType==='bullseye')
    // },
    onEditClicked(field) {
      let paramConfig = {
        optionType: this.optionType,
        option: field,
        colorScale: this.colorScales[this.fieldsItemsWithSegs.indexOf(field)],
      }
      this.$emit('edit', paramConfig)
    },
    onRemoveClicked(field) {
      let paramConfig = {
        optionType: this.optionType,
        option: field,
      }
      //Needed for population filter
      if (!paramConfig.option.id && paramConfig.option.fields.length > 0) {
        paramConfig.option.id = paramConfig.option.fields[0].id
      }
      this.$emit('remove', paramConfig)
    },
    nextColorScale() {
      let all = getColorScales(this.optionType, this.fieldsItemsWithSegs.length + 1)
      return all[all.length - 1]
    },
  },
  watch: {
    isSaving() {
      if (this.hasIonChannels) this.plotKey += 1
    }
  }
}
</script>

<style lang="stylus" scoped>
.trial-option-recap
  margin-bottom: 15px

  .bulls-eye-container
    margin-left: 5%
    width: 90%
    height: 260px

    .bullseye-diagram
      width: 100%
      height: 100%

  .separator
    margin-bottom: 15px
    padding-bottom: 15px
    border-bottom: solid 1px #eee

  .fields-container
    display: flex
    flex-direction: column

    .field-label
      color: $shuttle-gray
      m-font-size(12, 14)
      margin-bottom: 5px
      font-weight: $fw-light

    // ME HE INVENTADO ESTO, sino no se entendia nada...
    // NO VA bien, porque el v-modal añade unos hijos al final a veces...
    .field-item
      position: relative
      display: flex
      align-items: center
      padding: 15px
      border-radius: 4px
      background-color: $titan-white

      &:not(:last-child)
        margin-bottom: 10px

      &:hover
        .actions
          display: flex

      .left
        display: flex
        flex: 1 1 0%
        flex-direction: column

        .option-title
          m-font-size(14, 22)
          margin-bottom: 20px
          font-weight: $fw-semi-bold

        .legend-wrapper
          display: flex
          align-items: center

          .legend-title
            flex: 0 0 auto
            m-font-size(12, 18)
            font-weight: $fw-semi-bold
            max-width: 50%;

          .scale-as-dot
            margin: 0 20px
            width: 14px
            height: 14px
            border-radius: 14px

      .actions
        position: absolute
        top: 10px
        right: 10px
        display: flex
        display: none
        align-items: center

        // WTF?! xk els vas treure aquests?!
        .action-btn
          margin: 5px
          width: 28px
          height: 28px
          border: 1px solid $titan-white
          border-radius: 50%
          background-color: rgba(#fff, 0.7)
          background-position: center center
          background-size: 50% 50%
          background-repeat: no-repeat
          box-shadow: 0 5px 15px rgba($lynch, 0.25)
          cursor: pointer

          &:hover
            border: 1px solid $trout

          &.edit
            // m-icon('edit',20)
            background-image: url("~@/assets/icons/icon-edit.svg")

          &.remove
            // m-icon('edit',20)
            // ESTA MAL ESTe ICON!
            background-image: url("~@/assets/icons/icon-trash.svg")

>>> .input-container
  margin-bottom: 0

</style>

<style lang="stylus">

.field-info
  m-font-size(14, 16)
  color: #515662
  font-weight: $fw-light

  .value-input-component-container
    .input-component
      padding: 0

  &:not(:last-child)
    margin-bottom: 10px
</style>